// extracted by mini-css-extract-plugin
export default {"label":"WizardLabel_label__dHU15","text":"WizardLabel_text__BfZ3M"};